import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles'

/** Import component sections */
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import LoadingPage from '../common/LoadingPage'
import DataTable from '../common/DataTable'
import SearchInput from '../common/SearchInput/SearchInput'
import OptionsMenu from '../common/OptionsMenu'
import DonwloadReportDialog from '../common/DonwloadReportDialog'
import Toaster from '../common/Toaster'

/** Material-UI imports section */
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import NoticesOfChangeIcon from '@material-ui/icons/SwapHorizTwoTone'
import AddtIcon from '@material-ui/icons/AddTwoTone'
import ArchiveDownloadIcon from '@material-ui/icons/Archive'

import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Fab from '@material-ui/core/Fab'

/** Language imports **/
import { Translate, getTranslate } from 'react-localize-redux'

/** Import section actions */
import {
	loadNoticeChangesFromBackEnd,
	getNoticeChangesCount,
	downloadNoticeChangeReportByRangeDate,
	CHANGE_NOTICE_CHANGES_SORT_CRITERIA,
	CHANGE_NOTICE_CHANGES_QUERY,
	CHANGE_NOTICE_CHANGES_PAGINATION,
} from '../../store/noticeChanges/NoticeChangeAction'

import { IsCurrentActiveDirectoryUser } from '../../store/helpers/SessionHelper'
import { showSuccessToaster, showErrorToaster } from '../../store/helpers/ToasterHelpers'
import { canBeValidateModuleDevelopment } from '../../store/helpers/RolesHelper'
import { converListToArray } from '../../store/helpers/ListHelper'

/**
 * Notice changes view
 *
 * @class Notices
 * @extends {Component}
 */
class Index extends Component {
	/**
	 * Create an instance notices
	 * @param {*} props
	 */
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			itemToken: null,
			showMenu: true,
			openModalReport: false,
		}
	}

	/**
	 * componentDidMount
	 */
	componentDidMount() {
		if (!this.props.isLoadingUser) {
			this.props.loadNoticeChanges(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage
			)
			this.props.getNoticeChangesCount()
		}
	}

	/**
	 * componentDidUpdate
	 *
	 * @param {*} prevProps
	 * @param {*} prevState
	 * @memberof Index
	 */
	componentDidUpdate(prevProps, prevState) {
		let prevCompanyToken = prevProps.selectedCompany ? prevProps.selectedCompany.token : ''
		if (this.props.selectedCompany && prevCompanyToken !== this.props.selectedCompany.token) {
			this.props.loadNoticeChanges()
			this.props.getNoticeChangesCount()
		} else if (
			prevProps.sortCriteria.by !== this.props.sortCriteria.by ||
			prevProps.sortCriteria.ascending !== this.props.sortCriteria.ascending ||
			prevProps.searchQuery !== this.props.searchQuery ||
			prevProps.page !== this.props.page ||
			prevProps.rowsPerPage !== this.props.rowsPerPage
		) {
			this.props.loadNoticeChanges(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage
			)
		}
	}

	/**
	 * On change sort criteria
	 *
	 * @param {*} sortBy
	 * @param {*} sortAscending
	 * @memberof Index
	 */
	onChangeSortCriteria(sortBy, sortAscending) {
		this.props.changeSortCriteria(sortBy, sortAscending)
	}

	/**
	 * On change search value
	 *
	 * @param {*} searchQuery
	 * @memberof Index
	 */
	onChangeSearchValue(searchQuery) {
		this.props.changeSearchQuery(searchQuery)
	}

	/**
	 * Handle click of options menu component to set item Token in state nd open menu
	 *
	 * @param {*} token
	 * @memberof Index
	 */
	handleClickOptionsMenu(token) {
		this.setState({
			itemToken: token,
		})
	}

	/**
	 * Handle on close optons menu to set void item token in state
	 *
	 * @memberof Index
	 */
	handleCloseOptionsMenu() {
		if (!this.state.openModalReport) {
			this.setState(
				{
					itemToken: '',
					showMenu: false,
				},
				() => {
					this.setState({ showMenu: true })
				}
			)
		}
	}

	/**
	 * Open modal for set report by mont
	 *
	 * @memberof Index
	 */
	handleOpenModal() {
		this.setState({
			openModalReport: true,
		})
	}

	/**
	 * Close modal to report by month
	 *
	 * @memberof Index
	 */
	handleCloseModal() {
		this.setState(
			{
				openModalReport: false,
			},
			() => this.handleCloseOptionsMenu()
		)
		this.setState({ startDate: '', endDate: '' })
	}

	/**
	 *Download report of notice change by month
	 *
	 * @memberof Index
	 */
	onDownloadReportByRangeDate(startDate, endDate) {
		this.props
			.downloadNoticeChangeReportByRangeDate(startDate, endDate)
			.then(() => {
				this.setState(showSuccessToaster('common.addCorrectly'))
				this.handleCloseModal()
			})
			.catch(() => {
				this.setState(showErrorToaster('common.errorToDownload'))
			})
	}

	/**
	 *Render action button in card quality failure report
	 *
	 * @memberof Index
	 */
	renderAction() {
		var options = []
		options.push({
			itemClick: () => this.handleOpenModal(),
			tooltipTranslation: <Translate id='noticeChanges.downloadReportByNotice' />,
			menuItemIcon: <ArchiveDownloadIcon color='secondary' />,
			isLoading: this.props.isLoadingNotice,
		})
		if (this.state.showMenu)
			return (
				<OptionsMenu
					itemToken={'item.token'}
					handleClickOptions={this.handleClickOptionsMenu}
					open={this.state.itemToken === 'item.token'}
					handleClickAway={this.handleCloseOptionsMenu}
					options={options}
				/>
			)
	}

	/**
	 * onRenderCellItem
	 * @param {*} dataSource
	 * @param {*} item
	 */
	onRenderCellItem(dataSource, item) {
		let isActiveSupplier = IsCurrentActiveDirectoryUser(this.props.user)
		if (dataSource === 'supplier_name' && isActiveSupplier) {
			let supplierToShow = []
			if (item.supplier_name) {
				supplierToShow = item.supplier_name.split('-')
			}
			return (
				<div style={{ width: '280px' }}>
					{supplierToShow.map((supplier) => {
						return (
							<span>
								{supplier}
								<br />
							</span>
						)
					})}
				</div>
			)
		}
	}

	/**
	 * Get the card content
	 *
	 * @memberof Index
	 */
	getCardContent() {
		const { sortCriteria } = this.props
		if (this.props.isLoadingNoticeChanges === true) {
			return <LoadingPage />
		} else if (this.props.noticechanges === null) {
			return (
				<div className='loader-container'>
					<Typography variant='subtitle1' gutterBottom>
						{' '}
						<Translate id='common.errorToGetInformation' />
					</Typography>
				</div>
			)
		} else {
			return (
				<DataTable
					data={this.props.noticechanges}
					configuration={TableConfiguration(IsCurrentActiveDirectoryUser(this.props.user))}
					sortBy={sortCriteria.by}
					sortAscending={sortCriteria.ascending}
					onChangeSortCriteria={this.onChangeSortCriteria}
					onRenderCellItem={this.onRenderCellItem}
					onRowClick={(notice) => {
						this.props.history.push(`/noticechanges/${notice.token}`)
					}}
					showFilters
					isIndex
					totalRows={this.props.noticechangesCount}
					page={this.props.page}
					rowsPerPage={this.props.rowsPerPage}
					onChangePage={(newPage, newRowsPerPage) => {
						this.props.changePage(newPage, newRowsPerPage)
					}}
				/>
			)
		}
	}

	/**
	 * Get notice changes counter
	 *
	 * @returns
	 * @memberof Index
	 */
	getNoticeChangesCounterMessage() {
		const { classes } = this.props
		if (this.props.noticechanges) {
			let totalNotices = this.props.noticechanges.length
			return (
				<div>
					{this.props.translate('common.showing')}&nbsp;
					<span>{totalNotices}</span>&nbsp;
					{this.props.translate('common.of')}&nbsp;
					<span className={classes.totalNoticesCounter}>{this.props.noticechangesCount}</span>&nbsp;
					{this.props.translate('common.records')}
				</div>
			)
		}
	}

	/**
	 * Render
	 *
	 * @returns
	 * @memberof Notices
	 */
	render() {
		const { classes } = this.props
		return (
			<Card>
				<CardHeader
					avatar={
						<Avatar>
							<NoticesOfChangeIcon />
						</Avatar>
					}
					action={
						<div className={classes.actionsToolbar}>
							<SearchInput
								className={classes.searchInput}
								onChangeSearchValue={this.onChangeSearchValue}
								value={this.props.searchQuery}
							/>
							{IsCurrentActiveDirectoryUser(this.props.user) &&
								canBeValidateModuleDevelopment(this.props.userRolesByCompany) && (
									<Fab
										size='small'
										color='primary'
										onClick={() => {
											this.props.history.push(`/noticechanges/create`)
										}}
									>
										<AddtIcon />
									</Fab>
								)}

							{this.renderAction()}
						</div>
					}
					title={
						<Typography variant='button'>
							<Translate id='menu.noticeChange' />{' '}
						</Typography>
					}
					subheader={this.getNoticeChangesCounterMessage()}
				/>
				<CardContent>{this.getCardContent()}</CardContent>

				{/** Dialog to download report */}
				<DonwloadReportDialog
					title={<Translate id='noticeChanges.downloadReportByNotice' />}
					open={this.state.openModalReport}
					onClose={this.handleCloseModal}
					isSaving={this.props.isLoadingNotice}
					onDonwloadItems={this.onDownloadReportByRangeDate}
				/>

				<Toaster
					message={this.state.toasterMessage}
					open={this.state.showToaster}
					variant={this.state.toasterVariant}
					onClose={() => {
						this.setState({ showToaster: false })
					}}
				/>
			</Card>
		)
	}
}

function TableConfiguration(isUserInternal) {
	let columns = [
		{
			header: '',
			dataSource: 'status_indicator',
		},
		{
			header: <Translate id='common.status' />,
			dataSource: 'status_description',
			isSortable: true,
		},
		{
			header: <Translate id='common.folio' />,
			dataSource: 'folio',
			isSortable: true,
		},
		{
			header: <Translate id='common.creationDate' />,
			dataSource: 'creation_date',
			isSortable: true,
		},
		{
			header: <Translate id='noticeChanges.stage' />,
			dataSource: 'stage',
			isSortable: true,
		},
		{
			header: <Translate id='noticeChanges.developmentEngineer' />,
			dataSource: 'development_name',
		},
	]

	if (isUserInternal) {
		columns.push({
			header: <Translate id='common.supplier' />,
			dataSource: 'supplier_name',
			isSortable: true,
		})
	}

	return { columns }
}

/**
 *  Defines the properties injecteded from the store to view container
 * @param {*} state
 */
function mapStateToProps(state) {
	let user = state.oidc.user ? state.oidc.user : { profile: { name: '', email: '', user_type: '' } }
	let selectedCompany = state.profile.get('selectedCompany')
	let userRolesByCompany = state.profile.get('userRolesByCompany')
	return {
		user: user,
		selectedCompany: selectedCompany ? selectedCompany.toJS() : null,
		isLoadingUser: state.oidc.isLoadingUser,
		isLoadingNoticeChanges: state.noticechanges.get('isLoadingNoticeChanges'),
		isLoadingNotice: state.noticechanges.get('isLoadingNoticeChange'),
		noticechanges: state.noticechanges.get('noticechanges')
			? state.noticechanges.get('noticechanges').toJS()
			: null,
		sortCriteria: state.noticechanges.get('sortCriteria') ? state.noticechanges.get('sortCriteria').toJS() : null,
		searchQuery: state.noticechanges.get('searchQuery'),
		page: state.noticechanges.get('page'),
		rowsPerPage: state.noticechanges.get('rowsPerPage'),
		noticechangesCount: state.noticechanges.get('noticechangesCount'),
		translate: getTranslate(state.localize),
		userRolesByCompany: userRolesByCompany ? converListToArray(userRolesByCompany) : [],
	}
}

/**
 * Defines the actions injectes to the component
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) => {
	return {
		loadNoticeChanges: (query, orderBy, sortAscending, page, rowsPerPage) => {
			dispatch(loadNoticeChangesFromBackEnd(query, orderBy, sortAscending, page, rowsPerPage))
		},
		changeSortCriteria: (sortBy, sortAscending) => {
			dispatch({
				type: CHANGE_NOTICE_CHANGES_SORT_CRITERIA,
				sortCriteria: {
					by: sortBy,
					ascending: sortAscending,
				},
			})
		},
		changeSearchQuery: (query) => {
			dispatch({
				type: CHANGE_NOTICE_CHANGES_QUERY,
				query: query,
			})
		},
		changePage: (page, rowsPerPage) => {
			dispatch({
				type: CHANGE_NOTICE_CHANGES_PAGINATION,
				page,
				rowsPerPage,
			})
		},
		getNoticeChangesCount: () => {
			return dispatch(getNoticeChangesCount())
		},
		downloadNoticeChangeReportByRangeDate: (startDate, endDate) => {
			return dispatch(downloadNoticeChangeReportByRangeDate(startDate, endDate))
		},
	}
}

const styles = (theme) => ({
	avatar: {},
	actionsToolbar: {
		display: 'flex',
	},
	searchInput: {
		marginTop: '5px',
	},
	showingUsersCounter: {
		color: theme.palette.secondary.main,
	},
})

export default withauthenticatedLayout(
	withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Index)))
)
